import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { Text } from '../Text/Text.js';

function Avatar({
  size,
  alt = '',
  ...rest
}) {
  return jsx("div", {
    className: clsx('overflow-hidden rounded-full border-2 border-solid border-navy bg-green', 'flex shrink-0 justify-center', {
      'items-center': 'fullName' in rest
    }),
    style: {
      width: size,
      height: size
    },
    children: 'src' in rest ? jsx("img", {
      alt: alt,
      className: clsx('size-full object-cover'),
      src: rest.src
    }) : jsx(Text, {
      fontWeight: "semibold",
      variant: "h3",
      as: "h3",
      className: clsx('text-center text-navy'),
      children: rest.fullName.split(' ').map(n => n[0]).join('')
    })
  });
}

export { Avatar };
